var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "stocktransfer no-select",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "45px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "search_barT"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSubmitForSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 col-lg-4"
  }, [_vm._v("Search Type :")]), _vm._v(" "), _c('basic-select', {
    staticClass: "col-md-8 col-lg-8",
    staticStyle: {
      "display": "inline-block",
      "cursor": "none"
    },
    attrs: {
      "options": _vm.SelectTypeOptionArr,
      "selected-option": _vm.SelectTypeOptionObj,
      "placeholder": "Select Search Type"
    },
    on: {
      "select": _vm.selectTypeOption
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Reference Number :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "RefShippingID",
    staticClass: "form-control input_field_style ",
    class: {
      'is-invalid': _vm.submitted && _vm.errors.has('ShippingID')
    },
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "id": "ShippingID",
      "name": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSubmitForSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-times reset_btn",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.resetShippingDetails
    }
  }), _vm._v(" "), (_vm.submitted && _vm.errors.has('ShippingID')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" The Unique Reference\n                        Number field is required. ")]) : _vm._e()])]), _vm._v(" "), (_vm.SelectTypeOptionObj && _vm.SelectTypeOptionObj.value === 'ClientOrderID') ? _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 col-lg-2"
  }, [_vm._v("Client :")]), _vm._v(" "), _c('Multiselect', {
    staticClass: "col-md-8 col-lg-8",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.clientData,
      "name": "clientData",
      "selected-option": _vm.ClientOrderIDObj,
      "placeholder": "Select Client Order ID",
      "track-by": "text",
      "label": "text",
      "hide-selected": false
    },
    on: {
      "select": _vm.selectClientOrderID
    },
    model: {
      value: (_vm.search.client),
      callback: function($$v) {
        _vm.search.client = $$v
      },
      expression: "search.client"
    }
  })], 1)]) : _vm._e()])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "45px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "search_barT"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 col-lg-4"
  }, [_vm._v("Search Reason : ")]), _vm._v(" "), _c('basic-select', {
    key: _vm.SelectReasonOptionObj.value,
    staticClass: "col-md-8 col-lg-8",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.SelectReasonOptionArr,
      "selected-option": _vm.SelectReasonOptionObj,
      "placeholder": "Select Search Reason"
    },
    on: {
      "select": _vm.selectReasonOption
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-8",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "35.33%",
      "color": "#dc3545",
      "font-size": "0.875rem",
      "margin-top": "0.25rem"
    }
  }, [_vm._v("\n                        Please select valid Search Reason\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 col-lg-3 mr-3"
  }, [_vm._v("Remarks :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchPurpose),
      expression: "SearchPurpose"
    }],
    staticClass: "form-control input_field_style",
    class: {
      'is-invalid': _vm.SelectReasonOptionObj.value === 'Others' && !_vm.SearchPurpose
    },
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Remarks"
    },
    domProps: {
      "value": (_vm.SearchPurpose)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSubmitForSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchPurpose = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#1AB9D8",
      "margin-left": "5px",
      "cursor": "help",
      "font-size": "x-large"
    },
    attrs: {
      "title": _vm.remarksTooltipText
    }
  }), _vm._v(" "), (_vm.SelectReasonOptionObj.value === 'Others' && !_vm.SearchPurpose) ? _c('div', {
    staticClass: "invalid-feedback col-md-9 col-lg-9"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "30px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetTrackshipmentsummary
    }
  }, [_vm._v("\n                          Reset")])])])])])])])])])], 1)]), _vm._v(" "), (_vm.ShippingIDTypeMainDiv) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "id": "ShippingIDTypeMainDiv"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Customer Details")]), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [(_vm.IVRCallRecording.IVRCallPatchingBtn) ? _c('i', {
    staticClass: "fa fa-phone-square",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.OpenCallPatchingModel(_vm.CustomerDetails.PhoneNo, _vm.CustomerDetails.PhoneNoAlt,
          _vm.CustomerDetails.CustomerName, 'Customer Details')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Name :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.CustomerName) + "\n                          ")])]), _vm._v(" "), _c('thead', [(_vm.SalesDemo.IsRedirectToBank && _vm.SalesDemo.RedirectToAddress === 'Secondary') ? _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Banking Address :")]) : (_vm.SalesDemo.IsRedirect && _vm.SalesDemo.RedirectToAddress === 'Secondary') ? _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Secondary Address :")]) : _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Primary Address :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.Address))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Address Type :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [(_vm.IsCommercialProperty === true) ? _c('span', [_vm._v(_vm._s(_vm.constantVariable.WORK))]) : _c('span', [_vm._v(_vm._s(_vm.constantVariable.HOME))])])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("City :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.City))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("State :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.State))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Pin Code :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.PinCode))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("RTO Details")]) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("DTO Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [(_vm.UAPayload.RTODTOFeature === 'Y') ? _c('i', {
    staticClass: "fa fa-phone-square",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.OpenCallPatchingModel(_vm.RTODetails.PhoneNo, _vm.RTODetails.PhoneNoAlt,
          _vm.RTODetails.CustomerName, 'RTO Details')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.RTODetails.EmailID) ? _c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.RTODetails.EmailID))
    }
  }, [(_vm.DepartmentID != '181') ? _c('i', {
    staticClass: "fa fa-envelope-open",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Name :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.CustomerName))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v(" Address :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.Address))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("City :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.City))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("State :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.State))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Pin Code :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.PinCode))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Primary No. :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.PhoneNoDisplay) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Alternate No. :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.RTODetails.PhoneNoAltDisplay) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Email :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(_vm._s(_vm.RTODetails.EmailID))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [(_vm.SalesDemo.EscalationType === 2) ? _c('i', {
    staticClass: "fa fa-frown-o fa-icon-theme-color-red",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "title": _vm.EscalationType,
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.EscalationType === 1 || _vm.SalesDemo.EscalationMarkedbeforeDest) ? _c('i', {
    staticClass: "fa fa-meh-o fa-icon-theme-colorT fa-icon-theme-color-red",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "title": _vm.EscalationType,
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Shipping ID :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ShippingID))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Client Name :")]), _vm._v(" "), (_vm.SalesDemo.ClientID == '409') ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                             " + _vm._s(_vm.SalesDemo.SenderName) + "  (" + _vm._s(_vm.SalesDemo.ClientName) + ")")]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ClientName) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Service Type :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ServiceType))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Shipment Status :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s((_vm.SalesDemo.ShipmentStatus == 'Delivered' && _vm.IsManualDelivery) ? _vm.SalesDemo.ShipmentStatus + ' (Manual)' : _vm.SalesDemo.ShipmentStatus))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Status :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.Status))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Business Flow :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.BusinessFlow))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Is Heavy : ")]), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                             "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  })]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  })])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("MPS Group Id : ")]), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                             " + _vm._s(_vm.SalesDemo.MPSGroupId))]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" NA")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Prexo Type :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PrexoType))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Prexo Shipment:")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" \n                            "), (_vm.PrexoShipment && _vm.PrexoShipment !== 'NA') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'trackshipmentsummarydetail',
        params: {
          id: _vm.PrexoShipment
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.PrexoShipment))]) : _c('span', [_vm._v(_vm._s(_vm.PrexoShipment))])], 1)]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.DelayedDateStr) + "\n                          ")])])])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.SendSMS.SendSMSModal),
      callback: function($$v) {
        _vm.SendSMS.SendSMSModal = $$v
      },
      expression: "SendSMS.SendSMSModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SendSMS.SendSMSModal),
      expression: "SendSMS.SendSMSModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Send SMS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('SendSMSModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSendSMS($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.ReasonArr,
      "selected-option": _vm.SendSMS.SelectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedSMSReason
    },
    model: {
      value: (_vm.SendSMS.Reason),
      callback: function($$v) {
        _vm.SendSMS.Reason = $$v
      },
      expression: "SendSMS.Reason"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Reason')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                        " + _vm._s(_vm.errors.first('SendSMS.Reason')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.SendSMSArr,
      "selected-option": _vm.SendSMS.SelectedSendSMSObj,
      "placeholder": "Select Message"
    },
    model: {
      value: (_vm.SendSMS.Message),
      callback: function($$v) {
        _vm.SendSMS.Message = $$v
      },
      expression: "SendSMS.Message"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Message')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                        " + _vm._s(_vm.errors.first('SendSMS.Message')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send SMS")])])])], 1)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    model: {
      value: (_vm.Callpatching.CallPatchingModal),
      callback: function($$v) {
        _vm.Callpatching.CallPatchingModal = $$v
      },
      expression: "Callpatching.CallPatchingModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Callpatching.CallPatchingModal),
      expression: "Callpatching.CallPatchingModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Call Patching: " + _vm._s(_vm.Callpatching.addressType) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('CallPatchingModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.Callpatching.addressType === 'RTO Details') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Seller ID:")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.UAPayload.vendorId))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Shiping Id:")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(this.ShippingID))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.Callpatching.Name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Call Type:")]), _vm._v(" "), _c('div', [(_vm.CallTypeOptionObj.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CallType),
      expression: "CallType"
    }],
    staticClass: "select ",
    staticStyle: {
      "cursor": "pointer",
      "width": "150px",
      "height": "32px",
      "background-color": "rgb(255, 251, 251)",
      "border-color": "#7ca2e8",
      "text-align-last": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CallType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.CallTypeOptionObj), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })) : _vm._e(), _vm._v(" "), (_vm.CallTypeOptionObj.length == 0) ? _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Call type not available ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('a', {
    staticClass: "btn btn-success",
    staticStyle: {
      "color": "white",
      "margin-left": "15px"
    },
    attrs: {
      "href": '#/trackshipmentsummary'
    },
    on: {
      "click": function($event) {
        _vm.MakeCall()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" Call\n                    ")]), _vm._v("   \n                    "), _c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": '#/trackshipmentsummary'
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('CallPatchingModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Close ")])])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    class: {
      'glyphprogress': _vm.glyphprogress, 'short_glyphprogress': _vm.short_glyphprogress, 'short_short_glyphprogress': _vm.short_short_glyphprogress
    },
    attrs: {
      "id": "short_glyphprogress"
    }
  }, [_c('div', {
    class: {
      'connecting-line': _vm.connecting_line, 'short_connecting-line': _vm.short_connecting_line, 'short_short_connecting-line': _vm.short_short_connecting_line
    },
    attrs: {
      "id": "short_connecting-line"
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestManifestDataReceived ? 'blink_cls' : '']
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "#FF4500"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "limegreen"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.DataReceived))])]), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.OriginHubDataLiShow) ? _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestOriginHubInScan ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.OriginHubData) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.currentHubDataLiShow) ? _c('li', {
    attrs: {
      "id": "currentHubDataDivShow"
    }
  }, [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestCurrentHubInscanDate ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.currentHubData))])]) : _vm._e(), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.DestinationHubDataLiShow) ? _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestDestinationHubInscanDate ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.DestinationHubData))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestOFD ? 'blink_cls' : '']
  }, [_c('svg', {
    attrs: {
      "width": "50px",
      "height": "50px",
      "viewBox": "-7 -100 511 620",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "m235.46 42.352c0 23.387-18.957 42.344-42.344 42.344-23.383 0-42.344-18.957-42.344-42.344 0-23.383 18.961-42.34 42.344-42.34 23.387 0 42.344 18.957 42.344 42.34z",
      "fill": "#ffb69e"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m235.41 44.367c0.30469-6.2734-0.78516-12.715-3.4531-18.867-9.3047-21.453-34.242-31.297-55.695-21.992-16.609 7.207-26.254 23.785-25.445 40.859z",
      "fill": "#fa503c"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m260.21 44.531-57.281-0.16406c0.050781-11.285 9.2383-20.395 20.523-20.348l36.844 0.15625c5.6211 0.023438 10.16 4.6016 10.137 10.223-0.023438 5.6211-4.6016 10.156-10.223 10.133z",
      "fill": "#e83e29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m236.46 170.57-67.344-25.293c-10.371-3.8945-15.621-15.457-11.727-25.828 3.8945-10.371 15.461-15.621 25.828-11.727l61.492 23.094 67.793-16.945c10.746-2.6914 21.637 3.8438 24.324 14.594 2.6875 10.746-3.8477 21.637-14.594 24.32l-73.859 18.465c-3.8125 0.95312-7.9727 0.80078-11.914-0.67969z",
      "fill": "#f0a890"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m251.18 394.86c-12.105-5.5703-17.406-19.902-11.836-32.008l19.758-75.008-106.05-0.78906c-13.172-2.0312-22.203-14.359-20.168-27.531 2.0312-13.172 14.352-22.203 27.531-20.168l132.25 5.668c15.879 2.4531 26.27 19.426 19.59 33.938l-29.074 104.07c-5.582 12.137-19.93 17.391-32.008 11.832z",
      "fill": "#414b82"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m418.18 317.48c4.9805-65.445-55.102-92.211-55.102-92.211l-19.148-47.637h18.711c9.3125 0 17.223-7.6211 17.051-16.934-0.17188-9.0312-7.543-16.301-16.613-16.301h-40.059c-3.8398 0-7.6367 1.1641-10.645 3.543-5.2578 4.1523-7.4258 10.867-5.8594 17.117l57.043 224.93 1.5352 6.9844h-106.12c-18.164-52.082-67.703-89.457-125.98-89.457-68.051 0-124.2 50.957-132.37 116.8-1.1055 8.8906 5.8477 16.742 14.809 16.742h350.93c4.9258 0 9.1875 3.4258 10.246 8.2344 1.0625 4.8125 5.3242 8.2383 10.25 8.2383h94.664c9.0508 0 16.41-7.2344 16.613-16.234 0.003907-0.17188 0.007813-0.35547 0.007813-0.50781 0-54.859-32.879-102.18-79.965-123.31z",
      "fill": "#fa503c"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m204.07 440.91c0 39.262-31.828 71.086-71.086 71.086-39.258 0-71.082-31.824-71.082-71.086 0-39.258 31.824-71.082 71.082-71.082 39.258 0 71.086 31.824 71.086 71.082z",
      "fill": "#373c41"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m156.47 440.91c0 12.969-10.512 23.48-23.48 23.48s-23.48-10.512-23.48-23.48c0-12.965 10.512-23.477 23.48-23.477s23.48 10.512 23.48 23.477z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m132.6 281.77v-153.87c0-15.207 12.328-27.535 27.535-27.535h50.418c15.207 0 27.535 12.328 27.535 27.535v114.75z",
      "fill": "#55c7a6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m446.32 440.91c0 39.262-31.824 71.086-71.082 71.086-39.262 0-71.086-31.824-71.086-71.086 0-39.258 31.824-71.082 71.086-71.082 39.258 0 71.082 31.824 71.082 71.082z",
      "fill": "#373c41"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m398.71 440.91c0 12.9Surface69-10.512 23.48-23.477 23.48-12.969 0-23.48-10.512-23.48-23.48 0-12.965 10.512-23.477 23.48-23.477 12.965 0 23.477 10.512 23.477 23.477z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m317.5 201.46-75.59-9.0391c-3.168-0.37891-6.2031-1.5078-8.8477-3.293l-68.121-46.016c-9.1797-6.1992-11.594-18.668-5.3906-27.848 6.1992-9.1797 18.668-11.594 27.844-5.3945l64.098 43.297 70.77 8.4648c11 1.3164 18.848 11.301 17.535 22.297-1.3086 10.922-11.215 18.852-22.297 17.531z",
      "fill": "#ffb69e"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m220.58 132.29-33.18-22.414c-9.1797-6.1992-21.648-3.7852-27.848 5.3945-6.2031 9.1797-3.7852 21.648 5.3945 27.848l36.141 24.414z",
      "fill": "#39ae96"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m240.86 328.29h-191c-5.1484 0-9.3203-4.1719-9.3203-9.3203v-41.176c0-5.1484 4.1719-9.3242 9.3203-9.3242h191.01c5.1484 0 9.3203 4.1758 9.3203 9.3242v41.176c0 5.1484-4.1719 9.3203-9.3242 9.3203z",
      "fill": "#ffc305"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m108.55 268.47h-90.766c-6.8477 0-12.398-5.5508-12.398-12.395v-117.18c0-6.8477 5.5508-12.398 12.398-12.398h90.766c6.8438 0 12.395 5.5508 12.395 12.398v117.18c0 6.8438-5.5508 12.395-12.395 12.395z",
      "fill": "#965028"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important",
      "margin-top": "10px"
    }
  }, [_vm._v("EDD : " + _vm._s(_vm.SalesDemo.EDD) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important"
    }
  }, [_vm._v("PDD : " + _vm._s(_vm.SalesDemo.PDD))]), _vm._v(" "), (_vm.SalesDemo.IsLatestOFD) ? _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.SalesDemo.UserProcess) + " ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestDeliveryDateTime ? 'blink_cls' : '']
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "limegreen"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "#FF4500"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('span', [(_vm.SalesDemo.DeliveryDateTime && _vm.SalesDemo.Status === 'Delivered') ? _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("\n                        Delivery Status : Delivered\n                        "), _c('br'), _vm._v(" " + _vm._s(_vm.SalesDemo.DeliveryDateTime) + "\n                      ")]) : _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("Delivery Status : Pending")])]) : _c('span', [(_vm.SalesDemo.DeliveryDateTime && _vm.SalesDemo.ShipmentStatus === 'WHHandover') ? _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("DTO Status : WHHandover\n                        "), _c('br'), _vm._v(" " + _vm._s(_vm.SalesDemo.DeliveryDateTime) + "\n                      ")]) : _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("DTO Status : Pending")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingCurrentStatusDiv,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingCurrentStatusDiv = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "ext_btn"
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.showShipmentLogModal()
      }
    }
  }, [_vm._v("Shipment\n                Logs")]), _vm._v("   \n              "), _c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showTransitStatusModal()
      }
    }
  }, [_vm._v("Transit\n                Status")]), _vm._v("   \n              "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    on: {
      "click": function($event) {
        _vm.ShowRaiseTicketDiv();
      }
    }
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "id": "show-ticket-modal"
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Show\n                Tickets")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.emailTrackingModal = true;
        _vm.getEmailCasesByShipmentId(_vm.ShippingID)
      }
    }
  }, [_vm._v("Show\n                Emails")]), _vm._v("   \n            ")]), _vm._v(" "), (_vm.SalesDemo.BusinessFlow == 'Forward') ? _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Current Status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "title_txt"
  }, [(_vm.displayCurrentLocation && _vm.deliveryUserID) ? _c('span', [(_vm.DepartmentID === _vm.constantVariable.rto_dto_verification && _vm.UAPayload.RTODTOFeature === 'Y') ? _c('h6', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#167495",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.openSRGeofenceMap()
      }
    }
  }, [_vm._v("\n                \n                        " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                \n                      ")]) : _c('h6', {
    staticStyle: {
      "color": "#167495"
    }
  }, [_vm._v("\n                \n                        " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                \n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone popup",
    on: {
      "click": _vm.myPopupFunction
    }
  }, [_c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_vm._v("\n                          +91-" + _vm._s(_vm.OrderDetails.srUserData.MobileNumber) + "\n                        ")])]), _vm._v(" "), (_vm.UAPayload.RTODTOFeature === 'Y') ? _c('i', {
    staticClass: "fa fa-handshake-o",
    staticStyle: {
      "margin-left": "10px",
      "color": "#167495",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openHandoverSession
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Last NDR : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.lastNDRUserProcess) + "\n                            " + _vm._s(_vm.ShipmentTransactionLogSummary.LastNDRDate) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Type :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationType) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Status :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationStatus) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Total Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.TotalAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("RTO Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.RTOAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Reattempt Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ReattemptDate) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Escalation Tag :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.EscalationType) + " ")])])])])])])]), _vm._v(" "), (_vm.DepartmentID != '181') ? _c('b-tab', {
    attrs: {
      "title": "Product Dimensions"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Volumetric Weight :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.VolWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Physical Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.PhyWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Chargeable Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.BillableWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Width : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Width) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Height : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Height) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Length : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Length) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessType === 'BFSI' || _vm.CustomerAlternateAddress.Name || _vm.CustomerAlternateAddress.Address) ? _c('b-tab', {
    attrs: {
      "title": "Alternate Address"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.Name))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Address : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.CustomerAlternateAddress.Address) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("City : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.City))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("State : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.State))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pin Code : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.PinCode))]), _vm._v("\n                              \n                        ")])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow == 'Reverse') ? _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Current Status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "title_txt"
  }, [(_vm.displayCurrentLocation && _vm.deliveryUserID) ? _c('span', [(_vm.DepartmentID === _vm.constantVariable.rto_dto_verification) ? _c('h6', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#167495",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.openSRGeofenceMap()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                      ")]) : _c('h6', {
    staticStyle: {
      "color": "#167495"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone popup",
    on: {
      "click": _vm.myPopupFunction
    }
  }, [_c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_vm._v("+91-" + _vm._s(_vm.OrderDetails.srUserData.MobileNumber))])]), _vm._v(" "), (_vm.UAPayload.RTODTOFeature === 'Y') ? _c('i', {
    staticClass: "fa fa-handshake-o",
    staticStyle: {
      "margin-left": "10px",
      "color": "#167495",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openHandoverSession
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Last NPR : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.lastNDRUserProcess) + "\n                            " + _vm._s(_vm.ShipmentTransactionLogSummary.LastNDRDate) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Type :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationType) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Status :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationStatus) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Total Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.TotalAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("DTO Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.DTOAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Reattempt Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ReattemptDate) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Escalation Tag :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.EscalationType) + " ")])])])])])])]), _vm._v(" "), (_vm.DepartmentID != '181') ? _c('b-tab', {
    attrs: {
      "title": "Product Details"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Product Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ProductName))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [(_vm.DepartmentID == '5') ? _c('span', [_c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }), _vm._v("    \n                          ")]) : _c('span', [_c('th', [_vm._v("Product Id : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.ProductID) + " ")]), _vm._v("    \n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("POID : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.POID))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Product Qty : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.Quantity) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Return reason : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ReturnReason))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [(_vm.DepartmentID == '5') ? _c('span', [_c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }), _vm._v("    \n                          ")]) : _c('span', [_c('th', [_vm._v("Net Amount : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.DeclaredValue))]), _vm._v("    \n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pickup Item Count : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.SalesDemo.TotalAttemptCount))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MultipleProductInfo.MultipleProductInfoArr.length > 1),
      expression: "MultipleProductInfo.MultipleProductInfoArr.length > 1"
    }]
  }, [_c('th', [_c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMultipleProductInfoModal()
      }
    }
  }, [_vm._v("Product Info\n                            ")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.DepartmentID != '181') ? _c('b-tab', {
    attrs: {
      "title": "Product Dimensions"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Volumetric Weight :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.VolWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Physical Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.PhyWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Chargeable Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.BillableWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Width : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Width) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Height : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Height) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Length : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Length) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessType === 'BFSI' || _vm.CustomerAlternateAddress.Name || _vm.CustomerAlternateAddress.Address) ? _c('b-tab', {
    attrs: {
      "title": "Alternate Address"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.Name))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Address : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.CustomerAlternateAddress.Address) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("City : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.City))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("State : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.State))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pin Code : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.PinCode))]), _vm._v("\n                              \n                        ")])])])])])]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.MultipleProductInfo.MultipleProductInfoModal),
      callback: function($$v) {
        _vm.MultipleProductInfo.MultipleProductInfoModal = $$v
      },
      expression: "MultipleProductInfo.MultipleProductInfoModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MultipleProductInfo.MultipleProductInfoModal),
      expression: "MultipleProductInfo.MultipleProductInfoModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Product Info")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('MultipleProductInfo.MultipleProductInfoModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Product ID")]), _vm._v(" "), _c('th', [_vm._v("Product Name")]), _vm._v(" "), _c('th', [_vm._v("POID")]), _vm._v(" "), _c('th', [_vm._v("QC TemplateId")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.MultipleProductInfo.MultipleProductInfoArr), function(RowEle, index) {
    return (_vm.MultipleProductInfo.MultipleProductInfoArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.ProductID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.ProductName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.POID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.QCTemplateId))])]) : _vm._e()
  }))])])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 "
  }, [_c('loading', {
    attrs: {
      "active": _vm.OtherShipments.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.OtherShipments.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body  top_info_bodyT"
  }, [_c('div', {
    staticStyle: {
      "height": "250px"
    }
  }, [(_vm.OtherShipments.showChart) ? _c('DoughnutChart', {
    attrs: {
      "data": _vm.OtherShipments.chartData,
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RaiseTicketDiv),
      expression: "RaiseTicketDiv"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "id": "RaiseTicketDivUp"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Raise Ticket"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    on: {
      "click": function($event) {
        _vm.RaiseTicketDiv = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "ticketDiv"
  }, [_vm._v(_vm._s(_vm.ticketLabel))]), _vm._v(" "), (_vm.tableShipment == false) ? _c('label', {
    staticClass: "totalRecordLabel"
  }, [_vm._v(" Total Records :\n                          " + _vm._s(_vm.AllShipmentLogArrData.length))]) : _vm._e(), _vm._v(" "), (_vm.tableShipment == false) ? _c('div', {
    staticClass: "form-group shipmentDropDownSelect"
  }, [_c('label', [_vm._v("Shipment Category :")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.arrayofobj,
      "selected-option": _vm.categoryOptionObj,
      "placeholder": "Select Search Type"
    },
    on: {
      "select": _vm.selectedOptionObj
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableShipment == true) ? _c('div', {
    staticClass: "act_panel"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.ticketLabel == 'Raise Ticket' ? 'tableFixHead' : ''
  }, [(_vm.tableShipment == false) ? _c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.checkAllSelected,
      "name": "Select All"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "click": function($event) {
        _vm.selectAll($event)
      },
      "__c": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('th', [_vm._v("MPS Group ID")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AllShipmentLogArrData), function(OtherShipmentLogTblEle, index) {
    return (_vm.OtherShipmentLogCnt > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.OtherShipmentShippingIDCheckedArr),
        expression: "OtherShipmentShippingIDCheckedArr"
      }],
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "id": OtherShipmentLogTblEle.ShippingID,
        "type": "checkbox",
        "name": "Select All"
      },
      domProps: {
        "value": OtherShipmentLogTblEle.ShippingID,
        "checked": Array.isArray(_vm.OtherShipmentShippingIDCheckedArr) ? _vm._i(_vm.OtherShipmentShippingIDCheckedArr, OtherShipmentLogTblEle.ShippingID) > -1 : (_vm.OtherShipmentShippingIDCheckedArr)
      },
      on: {
        "click": function($event) {
          _vm.select(OtherShipmentLogTblEle, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.OtherShipmentShippingIDCheckedArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = OtherShipmentLogTblEle.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.OtherShipmentShippingIDCheckedArr = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: OtherShipmentLogTblEle.ShippingID
          }
        },
        "target": "_self"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.trackShipmentDetails(OtherShipmentLogTblEle.ShippingID)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.trackShipmentDetails(OtherShipmentLogTblEle.ShippingID)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(OtherShipmentLogTblEle.ShippingID))])], 1), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('td', [_vm._v(_vm._s(_vm.SalesDemo.MPSGroupId))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.TotalAttemptCount))])]) : _vm._e()
  }))]) : _vm._e()])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 tickeTopDiv"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v("\n                                : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), ((_vm.ticketTaggingDisplay == false && _vm.mobileNo != null) && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Primary No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10'),
      expression: "'required|digits:10'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "60px"
    },
    attrs: {
      "name": "mobileNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.mobileNo),
      callback: function($$v) {
        _vm.mobileNo = $$v
      },
      expression: "mobileNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobileNo')),
      expression: "errors.has('mobileNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobileNo')),
      expression: "errors.has('mobileNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('mobileNo')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "92px"
    }
  }, [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v("\n                                    : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "65px"
    }
  }, [_vm._v("Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "19px"
    }
  }, [_vm._v(" Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [(_vm.ticketTaggingDisplay == true) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_vm._v("Search Tagging : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tagging"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_vm._v("Address : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "address",
      "placeholder": "Enter Address",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_vm._v("PinCode : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    staticClass: "myplace",
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "pincode",
      "placeholder": "Enter Pincode"
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), (_vm.ndrReattemptDateflag ||
    (((_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update') || _vm.selectedReasonObj.text == 'Arrange pickup' || _vm.selectedReasonObj.text == 'Arrange delivery' || (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service') || (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in connection') || _vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE) && (_vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED))) ? _c('div', [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "43px"
    }
  }, [_vm._v("Reattempt Date\n                              "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), ((
    (_vm.selectedReasonObj.value === _vm.ndr_validation &&
      _vm.selectedSubReasonObj.value === _vm.verified_ndr) ||

    (_vm.selectedReasonObj.value === _vm.NPR_Validation &&
      _vm.selectedSubReasonObj.value === _vm.Verified_NPR) ||

    (_vm.selectedReasonObj.value === _vm.RTO_DTO_Validation &&
      _vm.selectedSubReasonObj.value === _vm.Verified_RTO_DTO_Reason)
  ) && _vm.searchOptionsNDRList.length > 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "53px"
    }
  }, [_vm._v("\n                              NDR Reasons "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                            ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchOptionsNDRList,
      "selected-option": _vm.selectedNDRReasonObj,
      "placeholder": "Select NDR reason"
    },
    on: {
      "select": _vm.selectedNDRReasonValue
    },
    model: {
      value: (_vm.ndrId),
      callback: function($$v) {
        _vm.ndrId = $$v
      },
      expression: "ndrId"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ndrverificationnote",
    staticStyle: {
      "margin-left": "160px",
      "color": "red",
      "font-size": "12px",
      "margin-top": "5px"
    }
  }, [_vm._v("\n                              Note : Please proceed with this action only after confirming with the SR and the customer.\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.childSubReasonList.length > 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "ndrsubreason_label_text"
  }, [_vm._v("\n                               NDR Sub Reasons "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                             ")]), _vm._v(" "), (_vm.childSubReasonList.length > 0) ? _c('basic-select', {
    attrs: {
      "options": _vm.childSubReasonList,
      "selected-option": _vm.selectedNDRSubReasonObj,
      "placeholder": "Select ndr sub reason"
    },
    on: {
      "select": _vm.selectedNDRSubReasonValue
    },
    model: {
      value: (_vm.subNdrId),
      callback: function($$v) {
        _vm.subNdrId = $$v
      },
      expression: "subNdrId"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.SalesDemo.BusinessFlow == 'Forward') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "43px"
    }
  }, [_vm._v("Payment Method : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "options": _vm.payMethods,
      "selected-option": _vm.selectedMethodObj,
      "placeholder": "Select Payment Method",
      "isDisabled": _vm.disPaymentMethod
    },
    on: {
      "select": _vm.selectedMethod
    },
    model: {
      value: (_vm.methodId),
      callback: function($$v) {
        _vm.methodId = $$v
      },
      expression: "methodId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('methodId')))])], 1) : _vm._e(), _vm._v(" "), (((_vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.orderTypeId == 'CashOnDelivery') || (_vm.selectedSubReasonObj.text == 'Change reverse amount')) && (_vm.selectedActionObj.value == _vm.STATUS_CHANGED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.PAYMENT_DETAILS_CHANGE_REQUESTED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "69px"
    }
  }, [_vm._v("Net Payment : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketTaggingDisplay == false && _vm.reasonId == _vm.ADDRESS_CHANGE && _vm.ticket.comments != null && _vm.ticket.comments != '') && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Previous Comments : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "60%",
      "height": "90px",
      "float": "right",
      "box-sizing": "border-box",
      "border": "1px solid rgba(216, 212, 212, 0.89)",
      "padding": "10px",
      "margin-right": "60px"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.ticket.comments))])]) : _vm._e(), _vm._v(" "), (((_vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM)) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && _vm.ticketTaggingDisplay == false && _vm.alternateContactNo != null && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "72px"
    }
  }, [_vm._v("Alternate No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "alternateContactNo",
      "placeholder": "Enter Alternate No"
    },
    model: {
      value: (_vm.alternateContactNo),
      callback: function($$v) {
        _vm.alternateContactNo = $$v
      },
      expression: "alternateContactNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticStyle: {
      "margin-left": "144px",
      "margin-top": "5px"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('alternateContactNo')))])])]) : _vm._e(), _vm._v(" "), (((_vm.selectedSubReasonObj.value == _vm.GENERATE_OTP && _vm.selectedActionObj.value == _vm.SEND_OTP) ||
    (_vm.ticketTaggingDisplay == false && _vm.primaryContactNo != null && _vm.selectedActionObj.value == _vm.SEND_OTP))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_vm._v("Primary Contact No :")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('digits:10|min:10|max:10'),
      expression: "'digits:10|min:10|max:10'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "primaryContactNo",
      "placeholder": "Primary Contact No"
    },
    model: {
      value: (_vm.primaryContactNoComputed),
      callback: function($$v) {
        _vm.primaryContactNoComputed = $$v
      },
      expression: "primaryContactNoComputed"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('primaryContactNo')),
      expression: "errors.has('primaryContactNo')"
    }],
    staticStyle: {
      "margin-left": "144px",
      "margin-top": "5px"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('primaryContactNo')),
      expression: "errors.has('primaryContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('primaryContactNo')))])])]) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.value == _vm.UPDATE_EMAIL_ADDRESS && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "60px"
    }
  }, [_vm._v("Email Address : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "emailAddress",
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailAddress')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "56px"
    }
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Ticket Status",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "105px"
    }
  }, [_vm._v("SR ID "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.SRIDs,
      "placeholder": "Select SR ID",
      "selected-option": _vm.selectedSRIDnObj
    },
    on: {
      "select": _vm.selectedSRID
    },
    model: {
      value: (_vm.SRIDsId),
      callback: function($$v) {
        _vm.SRIDsId = $$v
      },
      expression: "SRIDsId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "80px"
    }
  }, [_vm._v("SR Name "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.SRNames,
      "placeholder": "Select SR Name",
      "selected-option": _vm.selectedSRNamenObj
    },
    on: {
      "select": _vm.selectedSRName
    },
    model: {
      value: (_vm.SRNameId),
      callback: function($$v) {
        _vm.SRNameId = $$v
      },
      expression: "SRNameId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.DepartmentID == '214' && (_vm.selectedTicketStatusObj.value == 'Closed' || _vm.selectedTicketStatusObj.value == 'Follow Up'))) ? _c('div', [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Shippment ID")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.CustomerDetails.CustomerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.SalesDemo.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.RTODetails.Address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.SalesDemo.CreatedDate))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn btn-linkT"
  }, [_vm._v(" Proof of Delivery    "), _c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.viewSalesLink(_vm.IsWebLink, _vm.ticket)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.validateDocumentProof('valid')
      }
    }
  }, [_vm._v("Valid")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "20px",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.validateDocumentProof('invalid')
      }
    }
  }, [_vm._v("Invalid")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.previewImageModel),
      callback: function($$v) {
        _vm.previewImageModel = $$v
      },
      expression: "previewImageModel"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(" Proof of Delivery\n                              "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelPreviewImage
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])]), _vm._v(" "), _c('img', {
    staticClass: "wrapper",
    attrs: {
      "src": _vm.displayImageInBox,
      "width": "100%"
    },
    on: {
      "contextmenu": function($event) {
        $event.preventDefault();
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.ishubescalation === true) ? [(_vm.selectedSubReasonObj.tat) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "120px"
    }
  }, [_vm._v("TAT : ")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd",
      "display": "inline-block"
    },
    attrs: {
      "readonly": "",
      "placeholder": "TAT"
    },
    model: {
      value: (_vm.selectedSubReasonObj.tat),
      callback: function($$v) {
        _vm.selectedSubReasonObj.tat = $$v
      },
      expression: "selectedSubReasonObj.tat"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.priority) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("Priority : ")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd",
      "display": "inline-block"
    },
    attrs: {
      "readonly": "",
      "placeholder": "Priority"
    },
    model: {
      value: (_vm.selectedSubReasonObj.priority),
      callback: function($$v) {
        _vm.selectedSubReasonObj.priority = $$v
      },
      expression: "selectedSubReasonObj.priority"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "55px"
    }
  }, [_vm._v("Assigned to TL "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.assignedToTLOptions,
      "placeholder": "Select Assigned to TL",
      "selected-option": _vm.selectedAssignedToTLObj
    },
    on: {
      "select": _vm.selectedAssignedToTLOption
    },
    model: {
      value: (_vm.assignedToTLId),
      callback: function($$v) {
        _vm.assignedToTLId = $$v
      },
      expression: "assignedToTLId"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    staticStyle: {
      "max-height": "100px",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "placeholder": "",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "commentErrMsgCss"
  }, [_vm._v("Maximum 300 characters allowed.")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form_btn",
    staticStyle: {
      "position": "relative",
      "top": "94px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveTicketData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.ticketTaggingDisplay == true) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetForm($event)
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "All Shipments"
    },
    on: {
      "click": function($event) {
        _vm.selectedOptionObjAll()
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.AllShipmentLogArrData1 != '') ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "ticketDiv"
  }, [_vm._v("All Shipments")]), _vm._v(" "), (_vm.tableShipment == false) ? _c('label', {
    staticClass: "totalRecordLabel"
  }, [_vm._v(" Total Records :\n                          " + _vm._s(_vm.AllShipmentLogArrData1.length))]) : _vm._e(), _vm._v(" "), (_vm.tableShipment == true) ? _c('div', {
    staticClass: "act_panel"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.ticketLabel == 'Raise Ticket' ? 'tableFixHead' : ''
  }, [(_vm.tableShipment == false) ? _c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('th', [_vm._v("MPS Group ID")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AllShipmentLogArrData1), function(OtherShipmentLogTblEle, index) {
    return (_vm.OtherShipmentLogCnt > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: OtherShipmentLogTblEle.ShippingID
          }
        },
        "target": "_self"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.trackShipmentDetails(OtherShipmentLogTblEle.ShippingID)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.trackShipmentDetails(OtherShipmentLogTblEle.ShippingID)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(OtherShipmentLogTblEle.ShippingID))])], 1), _vm._v(" "), (_vm.SalesDemo.IsHeavies == true) ? _c('td', [_vm._v(_vm._s(_vm.SalesDemo.MPSGroupId))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.TotalAttemptCount))])]) : _vm._e()
  }))]) : _vm._e()])], 1) : _vm._e()])])], 1)], 1)])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.BagNumberTypeMainDiv) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "ext_btn"
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "id": ""
    },
    on: {
      "click": function($event) {
        _vm.showBagShipmentDetailsModal()
      }
    }
  }, [_vm._v("\n                Case Details")]), _vm._v("   \n              "), _c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.showBagShipmentDetailsModal()
      }
    }
  }, [_vm._v("\n                Shipment Details")]), _vm._v("   \n              "), _c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showTransitStatusModal()
      }
    }
  }, [_vm._v("Transit\n                Status")])]), _vm._v(" "), _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Bag Details"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Bag No:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.bagno))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Bag Type:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.bagtype))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Bag Status:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.bagstatus))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Created Date:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.createddate))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Created By:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.createdby))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Physical Weight:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.physicalweight))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Origin Hub Name:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.originhubname) + "\n                            (" + _vm._s(_vm.BagNoObj.BagDetails.originhubid) + ") ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Current Hub Name:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.currenthubname) + "\n                            (" + _vm._s(_vm.BagNoObj.BagDetails.currenthubid) + ") ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Destination Hub Name:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.destinationhubname) + "\n                            (" + _vm._s(_vm.BagNoObj.BagDetails.destinationhubid) + ") ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Last Modified Date:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.lastmodifieddate))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Last Modified By:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.lastmodifiedby))])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Volumetric Weight:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.BagNoObj.BagDetails.volumetricweight))])])])])])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Bag Log Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 scrollDivCls"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Process Location")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Created By")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.BagNoObj.AuditLogArr), function(RowEle, index) {
    return (_vm.BagNoObj.AuditLogArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.processlocationname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.createdby))])]) : _vm._e()
  }))])])], 1)])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.BagNoObj.BagShipmentDetailsModal),
      callback: function($$v) {
        _vm.BagNoObj.BagShipmentDetailsModal = $$v
      },
      expression: "BagNoObj.BagShipmentDetailsModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BagNoObj.BagShipmentDetailsModal),
      expression: "BagNoObj.BagShipmentDetailsModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('BagShipmentDetailsModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row scrollDivCls"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h6', {
    staticClass: "ship_id_head"
  }, [_vm._v("\n                      Parent Bag No : " + _vm._s(_vm.ShippingID) + "\n                         \n                      Total Shipment Count : " + _vm._s(_vm.BagNoObj.BagShipmentDetailsArr.length) + "\n                          BagIn Shipment Count : " + _vm._s(_vm.BagNoObj.BagInShipmentCount) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Bag No/Shipping Id")]), _vm._v(" "), _c('th', [_vm._v("Current Hub Id")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', [_vm._v("Chargeable Weight")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.BagNoObj.BagShipmentDetailsArr), function(RowEle, index) {
    return (_vm.BagNoObj.BagShipmentDetailsArr.length > 0) ? _c('tr', [(RowEle.shippingid) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: RowEle.shippingid
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(RowEle.shippingid))])], 1) : _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarybytype',
          params: {
            id: RowEle.bagno,
            type: 'B'
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(RowEle.bagno))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.currenthubid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.volumetricweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.physicalweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.chargeableweight))])]) : _vm._e()
  }))])])], 1)])])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.POIDTypeMainDiv) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom "
  }, [_c('thead', [_c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.poIdShipmentArr), function(poIdShipmentArrEle, index) {
    return (_vm.poIdShipmentArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(poIdShipmentArrEle.CreatedDate))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: poIdShipmentArrEle.ShippingID
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(poIdShipmentArrEle.ShippingID))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(poIdShipmentArrEle.BusinessFlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(poIdShipmentArrEle.BusinessAccountName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(poIdShipmentArrEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(poIdShipmentArrEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(poIdShipmentArrEle.TotalAttemptCount))])]) : _vm._e()
  }), _vm._v(" "), (_vm.poIdShipmentArr.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("Shipments not found")])]) : _vm._e()], 2)])])], 1)])])])])], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.MobileNumberTypeMainDiv) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom "
  }, [_c('thead', [_c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.OtherShipmentLogArr), function(OtherShipmentLogTblEle, index) {
    return (_vm.OtherShipmentLogCnt > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: OtherShipmentLogTblEle.ShippingID
          }
        },
        "target": "_self",
        "onclick": "window.location.reload() "
      }
    }, [_vm._v(_vm._s(OtherShipmentLogTblEle.ShippingID) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.BusinessFlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.TotalAttemptCount))])]) : _vm._e()
  }))])])], 1)])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.ClientOrderIDAWBModal) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom "
  }, [_c('thead', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")]), _vm._v(" "), _c('th', [_vm._v("Created Date")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.OrderIDAWBArr), function(shipment, index) {
    return (_vm.OrderIDAWBArr.length > 0) ? _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: shipment.value
          }
        },
        "target": "_self",
        "onclick": "window.location.reload() "
      },
      nativeOn: {
        "click": function($event) {
          _vm.trackAWBClick(shipment.value)
        }
      }
    }, [_vm._v(_vm._s(shipment.value) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.businessFlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.search.client.text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.currentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.attempts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.createdDate))])]) : _vm._e()
  }))])]), _vm._v(" "), (_vm.OrderIDPagination.totalPages > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.OrderIDPagination.totalPages,
      "margin-pages": 3,
      "click-handler": _vm.goToOrderIDPage,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.BagNoObj.TransitStatusModal),
      callback: function($$v) {
        _vm.BagNoObj.TransitStatusModal = $$v
      },
      expression: "BagNoObj.TransitStatusModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BagNoObj.TransitStatusModal),
      expression: "BagNoObj.TransitStatusModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Transit Status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('TransitStatusModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Source Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Connection Name")]), _vm._v(" "), _c('th', [_vm._v("Coloader/Vendor Name")]), _vm._v(" "), _c('th', [_vm._v("Route Mode")]), _vm._v(" "), _c('th', [_vm._v("Schedule Date")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.BagNoObj.TransitStatusArr), function(RowEle, index) {
    return (_vm.BagNoObj.TransitStatusArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.originhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.destinationhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.connectionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.transpotername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.routemode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.scheduledate))])]) : _vm._e()
  }))])])], 1)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.ShipmentLogModal),
      callback: function($$v) {
        _vm.ShipmentLogModal = $$v
      },
      expression: "ShipmentLogModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShipmentLogModal),
      expression: "ShipmentLogModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "display": "inline-block",
      "margin-bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "title": "Shipment Log"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "40px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ShipmentLogModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "40px",
      "left": "10%"
    }
  }, [_vm._v("Shipment : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ShippingID))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row rowFullTableT"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12 ShipmentLogDivT tableFixHeadTT",
    staticStyle: {
      "margin-top": "-30px!important"
    }
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Created By")])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-body"
  }, _vm._l((_vm.sorArrtByDate(_vm.ShipmentLog.ShipmentLogBarArr)), function(ShipmentLogTblEle, index) {
    return (_vm.ShipmentLog.ShipmentLogCnt > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "max-width": "70px"
      }
    }, [_vm._v(_vm._s(ShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.ProcessLocation))]), _vm._v(" "), (ShipmentLogTblEle.BagNo) ? _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserProcess) + "\n                        "), _c('br'), _vm._v(" (Bag No : " + _vm._s(ShipmentLogTblEle.BagNo) + ")\n                      ")]) : _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.Comments))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "max-width": "160px"
      }
    }, [_vm._v(_vm._s(ShipmentLogTblEle.UserName))])]) : _vm._e()
  }))])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.locationMapModal),
      callback: function($$v) {
        _vm.locationMapModal = $$v
      },
      expression: "locationMapModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationMapModal),
      expression: "locationMapModal"
    }],
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Location Map")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('locationMapModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "accordian-body",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": 'map' + _vm.ShippingID
    }
  })])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.Ticketmodal),
      callback: function($$v) {
        _vm.Ticketmodal = $$v
      },
      expression: "Ticketmodal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Ticketmodal),
      expression: "Ticketmodal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h6', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Ticket History")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head"
  }, [_vm._v("Shipment Id : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ShippingID))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('Ticketmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [(_vm.counter == 0) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.filter.length == 0) ? _c('div', {
    staticClass: "search_bar"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "10px",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "btnSearch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.OnFilterClick($event)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    ref: "search",
    staticClass: " form-control col-md-2",
    staticStyle: {
      "float": "right",
      "margin-right": "13px"
    },
    attrs: {
      "type": "text",
      "title": "Search by any column-name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.OnFilterClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "search_bar"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "10px",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "btnSearch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.OnFilterClick($event)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: " form-control col-md-2",
    staticStyle: {
      "float": "right",
      "margin-right": "13px"
    },
    attrs: {
      "type": "text",
      "autofocus": "",
      "title": "Search by any column-name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Ticket ID")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Ticket Type")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Sub Reason")]), _vm._v(" "), _c('th', [_vm._v("Resolution")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Department")]), _vm._v(" "), _c('th', [_vm._v("Priority")]), _vm._v(" "), _c('th', [_vm._v("TAT")]), _vm._v(" "), _c('th', [_vm._v("Aging Days")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Ticket Log")])]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, [_vm._l((_vm.shipmentTickets), function(ticket, index) {
    return (_vm.shipmentTickets.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(ticket.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.adlinfo && ticket.adlinfo.department ? ticket.adlinfo.department : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.priority))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.tat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.aging_days))]), _vm._v(" "), _c('td', [(ticket.ticketstatus != 'Closed') ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.editTicket(ticket)
        }
      }
    }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Closed' && ticket.clientid != null) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.editTicket(ticket)
        }
      }
    }, [_vm._v("Reopen")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Closed' && ticket.subreasonid == _vm.constantVariable.GOVT_ID_VERIFY && _vm.DepartmentID == _vm.constantVariable.POD && _vm.Role.rolename == _vm.constantVariable.TEAM_LEADER) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "View Govt ID Proof"
      },
      on: {
        "click": function($event) {
          _vm.viewSalesLink(_vm.IsWebLink, ticket)
        }
      }
    }, [_vm._v("Govt Id Proof")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getTicketHistory(ticket)
        }
      }
    }, [_vm._v("View")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentTickets.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("Tickets not found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pagecount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pagecount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.previewImageModel),
      callback: function($$v) {
        _vm.previewImageModel = $$v
      },
      expression: "previewImageModel"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(" Proof of Delivery\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelPreviewImage
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])]), _vm._v(" "), _c('img', {
    staticClass: "wrapper",
    attrs: {
      "src": _vm.displayImageInBox,
      "width": "100%"
    },
    on: {
      "contextmenu": function($event) {
        $event.preventDefault();
      }
    }
  })])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.TicketLogModal),
      callback: function($$v) {
        _vm.TicketLogModal = $$v
      },
      expression: "TicketLogModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TicketLogModal),
      expression: "TicketLogModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h6', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Ticket log")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head"
  }, [_vm._v("Ticket Id : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ticketIDLog))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('TicketLogModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Last updated on")]), _vm._v(" "), _c('th', [_vm._v("Resolution")]), _vm._v(" "), _c('th', [_vm._v("Ticket Status")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), (_vm.shouldShowSRLabel) ? _c('th', [_vm._v("SR ID")]) : _vm._e(), _vm._v(" "), (_vm.shouldShowSRLabel) ? _c('th', [_vm._v("SR Name")]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, [_vm._l((_vm.resultTicket), function(ticket, index) {
    return (_vm.resultTicket.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.comments))]), _vm._v(" "), (_vm.shouldShowSRLabel) ? _c('td', [_vm._v(_vm._s(ticket.adlinfo.SrID))]) : _vm._e(), _vm._v(" "), (_vm.shouldShowSRLabel) ? _c('td', [_vm._v(_vm._s(ticket.adlinfo.SrName))]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.resultTicket.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("Ticket Logs not found")])]) : _vm._e()], 2)])])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.ticketResultModal),
      callback: function($$v) {
        _vm.ticketResultModal = $$v
      },
      expression: "ticketResultModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticketResultModal),
      expression: "ticketResultModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Result")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg) + "\n                ")]), _vm._v(" "), (_vm.ticket.length > 0) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal');
        _vm.listExisitngTicketModal = true;
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Update\n                  Ticket")]) : _vm._e(), _vm._v(" "), (_vm.ticketResultMsg && (_vm.ticketResultMsg.toLowerCase().includes('vendorgroup') || _vm.ticketResultMsg.toLowerCase().includes('vendor group'))) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal');
        _vm.retryCreateTicket();
      }
    }
  }, [_vm._v("Please retry for failed batch")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": '#/trackshipmentsummary'
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Close ")])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.IVRCallRecording.IVRCallRecordingModal),
      callback: function($$v) {
        _vm.IVRCallRecording.IVRCallRecordingModal = $$v
      },
      expression: "IVRCallRecording.IVRCallRecordingModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IVRCallRecording.IVRCallRecordingModal),
      expression: "IVRCallRecording.IVRCallRecordingModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("IVR Call Recording")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('IVRCallRecording.IVRCallRecordingModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v(" Process")]), _vm._v(" "), _c('th', [_vm._v("Queue")]), _vm._v(" "), _c('th', [_vm._v("Call Date")]), _vm._v(" "), _c('th', [_vm._v("Call Duration")]), _vm._v(" "), _c('th', [_vm._v("Recording")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.IVRCallRecording.IVRCallRecordingArr), function(RowEle, index) {
    return (_vm.IVRCallRecording.IVRCallRecordingArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.queue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.calldate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.duration))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-file-audio-o fa-warningT",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.getIVRCallRecordingUrl(("" + (RowEle.uniqueid)))
        }
      }
    })])]) : _vm._e()
  }))])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.IVRCallRecording.IVRCallRecordingUrlModal),
      callback: function($$v) {
        _vm.IVRCallRecording.IVRCallRecordingUrlModal = $$v
      },
      expression: "IVRCallRecording.IVRCallRecordingUrlModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IVRCallRecording.IVRCallRecordingUrlModal),
      expression: "IVRCallRecording.IVRCallRecordingUrlModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("IVR Call Recording")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeIVRCallRecordingUrlModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTableT"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('center', [_c('vue-audio', {
    attrs: {
      "file": _vm.IVRCallRecording.AudioUrl
    }
  })], 1)], 1)])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.listExisitngTicketModal),
      callback: function($$v) {
        _vm.listExisitngTicketModal = $$v
      },
      expression: "listExisitngTicketModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Update Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetUpdateTicketModal(), _vm.listExisitngTicketModal = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.openUpdateTicketModal();
      }
    }
  }, [_vm._v("Update\n                Ticket")]), _vm._v(" "), (_vm.updateExistingBulkTicket == false) ? _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Back")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "col-md-12 col-lg-12",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllRecord),
      expression: "selectAllRecord"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllRecord) ? _vm._i(_vm.selectAllRecord, null) > -1 : (_vm.selectAllRecord)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAllRecord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllRecord = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllRecord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllRecord = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sub reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ticket), function(data, index) {
    return (_vm.ticket.length > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ticketIDS),
        expression: "ticketIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "id": data.ticketid,
        "type": "checkbox"
      },
      domProps: {
        "value": data.ticketid,
        "checked": Array.isArray(_vm.ticketIDS) ? _vm._i(_vm.ticketIDS, data.ticketid) > -1 : (_vm.ticketIDS)
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(data, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.ticketIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.ticketid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ticketIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ticketIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ticketIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.ticket.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBulkTicketDiv),
      expression: "showBulkTicketDiv"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "id": "bulkEditTicketDiv"
    }
  }, [_c('div', {
    staticClass: "row scrollDivShipmentGrid"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Source\n                    "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "49%"
    },
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED)) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Address : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    staticClass: "txtModalAddress",
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "address",
      "placeholder": "",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.newAddress),
      callback: function($$v) {
        _vm.newAddress = $$v
      },
      expression: "newAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Reason\n                    "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED)) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("PinCode : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    staticClass: "txtModalPincode",
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "pincode",
      "placeholder": ""
    },
    model: {
      value: (_vm.newPincode),
      callback: function($$v) {
        _vm.newPincode = $$v
      },
      expression: "newPincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), (((_vm.ticketShipmentData.length == 1 && (_vm.selectedReasonObj.text == 'Arrange delivery' ||
      (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service') ||
      (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in connection') ||
      (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update') ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedReasonObj.text == 'Arrange pickup') && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED) ||
    (_vm.ticketShipmentData.length > 1 && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED))) ? _c('div', [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Reattempt Date\n                      "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.newReAttemptDate),
      callback: function($$v) {
        _vm.newReAttemptDate = $$v
      },
      expression: "newReAttemptDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount') ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Payment Method : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.payMethods,
      "selected-option": _vm.selectedMethodObj,
      "placeholder": "Select Payment Method",
      "isDisabled": _vm.disPaymentMethod
    },
    on: {
      "select": _vm.selectedMethod
    },
    model: {
      value: (_vm.methodId),
      callback: function($$v) {
        _vm.methodId = $$v
      },
      expression: "methodId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('methodId')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Sub\n                    Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO &&
    (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && (_vm.newAlternateContactNo != null || _vm.newAlternateContactNo != undefined) && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Contact No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "newAlternateContactNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.newAlternateContactNo),
      callback: function($$v) {
        _vm.newAlternateContactNo = $$v
      },
      expression: "newAlternateContactNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newAlternateContactNo')),
      expression: "errors.has('newAlternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newAlternateContactNo')),
      expression: "errors.has('newAlternateContactNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newAlternateContactNo')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_EMAIL_ADDRESS &&
    (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Email Address : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txtModalEmailAddress",
    attrs: {
      "name": "emailAddress",
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.newEmailAddress),
      callback: function($$v) {
        _vm.newEmailAddress = $$v
      },
      expression: "newEmailAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailAddress')))])], 1) : _vm._e(), _vm._v(" "), ((((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.orderTypeId == 'CashOnDelivery') || (_vm.selectedSubReasonObj.text == 'Change reverse amount')) &&
    (_vm.selectedActionObj.value == _vm.STATUS_CHANGED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.PAYMENT_DETAILS_CHANGE_REQUESTED))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Net Payment : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticClass: "txtModalNetPayment",
    staticStyle: {
      "width": "59%",
      "float": "right",
      "margin-right": "28px"
    },
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.updateSelectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                  ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Status",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("SR ID "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                  ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.SRIDs,
      "placeholder": "Select SR ID",
      "selected-option": _vm.selectedSRIDnObj
    },
    on: {
      "select": _vm.selectedSRID
    },
    model: {
      value: (_vm.SRIDsId),
      callback: function($$v) {
        _vm.SRIDsId = $$v
      },
      expression: "SRIDsId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("SR Name "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                  ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.SRNames,
      "placeholder": "Select SR Name",
      "selected-option": _vm.selectedSRNamenObj
    },
    on: {
      "select": _vm.selectedSRName
    },
    model: {
      value: (_vm.SRNameId),
      callback: function($$v) {
        _vm.SRNameId = $$v
      },
      expression: "SRNameId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    staticClass: "model-form-textarea",
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form_btn",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkEditShipment($event)
      }
    }
  }, [_vm._v("Save")])])])])])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.emailTrackingModal),
      callback: function($$v) {
        _vm.emailTrackingModal = $$v
      },
      expression: "emailTrackingModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Email Cases")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "40px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleModalClose
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('trackingemailtracking', {
    ref: "trackingemailtracking",
    attrs: {
      "setShippingID": _vm.ShippingID,
      "setEmailCases": _vm.emailCasesArray,
      "setTotalCount": _vm.totalCount
    }
  }), _vm._v(" "), (_vm.totalcount0Div == true) ? _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("No emails found")])]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "shown": _vm.loadGeofenceMap,
      "hidden": _vm.closeGeofenceMap
    },
    model: {
      value: (_vm.showMapModal),
      callback: function($$v) {
        _vm.showMapModal = $$v
      },
      expression: "showMapModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMapModal),
      expression: "showMapModal"
    }],
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "font-weight": "700",
      "margin": "0"
    }
  }, [_vm._v("\n            Location Validation\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeGeofenceMap()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px",
      "border-radius": "8px",
      "overflow": "hidden"
    },
    attrs: {
      "id": "geofenceMap"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #e0e0e0",
      "border-radius": "8px",
      "padding": "20px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-bottom": "20px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                Geo Details\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "15px",
      "padding-bottom": "10px",
      "border-bottom": "1px solid #f0f0f0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#080808"
    }
  }, [_vm._v("Distance to Seller")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff6b6b",
      "font-weight": "600"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.geofenceData.distance) + " meters\n                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "15px",
      "padding-bottom": "10px",
      "border-bottom": "1px solid #f0f0f0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Geo Status")]), _vm._v(" "), _c('span', {
    style: ({
      padding: '6px 10px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '600',
      backgroundColor: _vm.geofenceData.isInsideGeoFence ? '#e0f5e0' : '#ffe0e0',
      color: _vm.geofenceData.isInsideGeoFence ? '#2e7d32' : '#d32f2f'
    })
  }, [_vm._v("\n                  " + _vm._s(_vm.geofenceData.isInsideGeoFence ? 'INSIDE GEOFENCE' : 'OUTSIDE GEOFENCE') + "\n                ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "6px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#070707"
    }
  }, [_vm._v("Seller Geo Confidence")]), _vm._v(" "), _c('span', {
    style: ({
      fontWeight: '600',
      color: _vm.geofenceData.sellerGeoConfidence === 'HIGH' ? '#2e7d32' : _vm.geofenceData.sellerGeoConfidence === 'MEDIUM' ? '#f9a825' : _vm.geofenceData.sellerGeoConfidence === 'LOW' ? '#d32f2f' : '#999'
    })
  }, [_vm._v("\n                    " + _vm._s(_vm.geofenceData.sellerGeoConfidence) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #e0e0e0",
      "border-radius": "8px",
      "padding": "20px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-bottom": "15px",
      "font-weight": "600"
    }
  }, [_vm._v("\n      Credibility Signal (BIC Model)\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fce4ec",
      "border-radius": "8px",
      "padding": "20px",
      "text-align": "center",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#070606",
      "font-size": "13px"
    }
  }, [_vm._v("\n        CREDIBILITY GAP\n      ")]), _vm._v(" "), _c('div', {
    style: ({
      color: _vm.credibilityData.riskLabel === 'HIGH RISK' ? '#c41c3b' : '#2e7d32',
      fontSize: '34px',
      fontWeight: '700'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.credibilityData.credibilityGap) + "%\n      ")]), _vm._v(" "), _c('div', {
    style: ({
      color: _vm.credibilityData.riskLabel === 'HIGH RISK' ? '#c41c3b' : '#2e7d32',
      fontWeight: '600'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.credibilityData.riskLabel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0e0d0d"
    }
  }, [_vm._v("\n        Seller Acceptance Benchmark\n      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.credibilityData.sellerBenchmark) + "%")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "18px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0a0a0a"
    }
  }, [_vm._v("\n        Current SR Handover Rate\n      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff6b6b",
      "font-weight": "600"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.credibilityData.maxSRScore) + "%\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "11px",
      "color": "#555",
      "margin-bottom": "15px",
      "font-style": "italic"
    }
  }, [_vm._v("\n          • Gap > 15% (High risk): SR is materially below expected performance. High probability of fake NDR / non-compliance."), _c('br'), _vm._v("\n          • Gap < 0% (Low risk): SR is overperforming the benchmark. Seller is likely rejecting intentionally.\n        ")])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showHandoverModal),
      callback: function($$v) {
        _vm.showHandoverModal = $$v
      },
      expression: "showHandoverModal"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#f7f7f7",
      "border-radius": "10px",
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "18px"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "700",
      "margin": "0",
      "color": "#333"
    }
  }, [_vm._v("\n        Handover Session (" + _vm._s(_vm.SalesDemo.UserProcess) + ": " + _vm._s(_vm.UAPayload.vendorId) + ")\n      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background": "#e6e6e6",
      "padding": "5px 12px",
      "border-radius": "20px",
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.batchCount) + " BATCHES\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closehandover()
      }
    }
  }, [_vm._v("\n        ×\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "420px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm mb-0",
    staticStyle: {
      "border-collapse": "separate",
      "border-spacing": "0 10px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background": "#f0f0f0"
    }
  }, [_c('th', {
    staticStyle: {
      "font-weight": "700",
      "padding": "12px 14px",
      "border-radius": "6px 0 0 6px"
    }
  }, [_vm._v("\n              Batch ID\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "700",
      "padding": "12px 14px",
      "border-radius": "0 6px 6px 0"
    }
  }, [_vm._v("\n              Total\n            ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentDetails), function(item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "background": "white",
        "box-shadow": "0 1px 4px rgba(0,0,0,0.05)",
        "border-radius": "6px"
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "12px 14px",
        "font-weight": "600"
      }
    }, [_vm._v("\n              " + _vm._s(item.vendorGroupNo) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "padding": "12px 14px",
        "font-weight": "500"
      }
    }, [_vm._v("\n              " + _vm._s(item.total) + "\n            ")])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#e9ecef",
      "font-weight": "700"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "12px 14px"
    }
  }, [_vm._v("\n              Aggregate\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "12px 14px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.aggregateTotal) + "\n            ")])])], 2)])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Other Shipment Chart")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ce220a","hasScoped":true}!./src/views/components/trackshipmentsummary/trackshipmentsummary.component.html
// module id = 865
// module chunks = 1